import { render, staticRenderFns } from "./ControlsRooms.vue?vue&type=template&id=263dcbc2&scoped=true"
import script from "./ControlsRooms.vue?vue&type=script&lang=js"
export * from "./ControlsRooms.vue?vue&type=script&lang=js"
import style0 from "./ControlsRooms.vue?vue&type=style&index=0&id=263dcbc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263dcbc2",
  null
  
)

export default component.exports